import React, { ReactElement, useState } from 'react';

import { Col, Flex, Row, Typography, Section } from 'components';

import { LiveMeetingAttendanceConfirmationStatusEnum, LiveVideoCard } from 'app/types/cards/LiveVideoCard';
import { LivesCard } from 'features/lives';
import Button from 'components/button';
import { Icon } from 'components/icon';
import styled, { useTheme } from 'styled-components';
import { useBreakpoints } from 'app/hooks';

interface EventListLivesProps {
  lives: LiveVideoCard[];
  productClassUuid: string;
  enrolled: boolean;
}

const ListIcon = styled(Icon)`
  width: 24px;
`;

const EventListLives = ({ lives, productClassUuid, enrolled }: EventListLivesProps): ReactElement => {
  const breakpoint = useBreakpoints();
  const [showList, setShowList] = useState(breakpoint === 'desktop' ? false : true);

  const theme = useTheme();
  return (
    <Flex bg="gray_200" flexGrow={1}>
      <Section flexDirection="column" flexGrow={0}>
        <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end" flexGrow={0} mb={10}>
          <Flex flexGrow={0}>
            <Typography type="type8" fontWeight="bold" color="dark_350">
              Programação
            </Typography>
          </Flex>

          <Button
            outline
            type="button"
            paddingY={16}
            paddingX={24}
            height="auto"
            width={316}
            bg="gray_500"
            color="white"
            colorHover="white"
            size="small"
            onClick={() => setShowList(!showList)}
          >
            {showList ? 'Ver em card' : 'Ver em lista'}
            <Flex ml={2} flexGrow={0}>
              <ListIcon icon={showList ? 'gridView' : 'formatListBulleted'} color={theme.colors.gray_500} />
            </Flex>
          </Button>
        </Flex>

        {Boolean(lives.length) ? (
          <>
            {!showList ? (
              <Row gutter={20} flexGrow={0}>
                {lives.map((live, index) => (
                  <Col key={index.toString()} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mt={{ m: 30 }}>
                    <LivesCard
                      live={live}
                      productClassUuid={productClassUuid}
                      enrolled={enrolled}
                      boxSmall={showList}
                      hideButton={!live.externalLiveMeetingInvitationUrl}
                    />
                  </Col>
                ))}
              </Row>
            ) : (
              lives.map((live, index) => (
                <LivesCard
                  live={live}
                  productClassUuid={productClassUuid}
                  enrolled={enrolled}
                  boxSmall={showList}
                  hideButton={!live.externalLiveMeetingInvitationUrl}
                />
              ))
            )}
          </>
        ) : (
          <Flex mt={30}>
            <Typography type="type5" color="alert_400" fontWeight="bold">
              Nenhuma live foi encontrada.
            </Typography>
          </Flex>
        )}
      </Section>
    </Flex>
  );
};

export default EventListLives;
